import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  Form,
  Button,
  Spinner,
  Table,
  Modal,
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useSelector } from "react-redux";
import Pagination from "../Common/Pagination";

const DeleteBillHistory = () => {
  const userState = useSelector(state => state?.loginData?.userData);
  const financialYear = useSelector((state) => state.activeData.financialYear);
  const activeKey = useSelector((state) => state.activeData?.activeNumberKey?.activeKey);
  const navigate = useNavigate();

  const [contractor, setContractor] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [apiLoader, setApiLoader] = useState(false);

  const [pageNo, setPageNo] = useState(1);
  const [docPerPage, setDocPerPage] = useState(50);
  const [noOfPages, setNoOfPages] = useState(0);

  const handlePageChange = (pageNumber) => {
    setPageNo(pageNumber);
  };

  const handleDocsPerPage = (docsPageProp) => {
    setPageNo(1);
    setDocPerPage(docsPageProp);
  };

  useEffect(() => {
    getVisitReportList();
  }, [docPerPage, pageNo, financialYear]);

  const getVisitReportList = async () => {
    setApiLoader(true);
    await fetch(
      process.env.REACT_APP_BASE_URL +
      `${userState?.usertype_keyname?.includes("zonalofficer")
        ? "/billDistribution/getDeletedBill"
        : userState?.usertype_keyname?.includes("mavim")
          ? "/billDistribution/getMavimDeletedBills"
          : "/billDistribution/getDeletedBill"
      }`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          propertyCode: "",
          documentsPerPage: docPerPage,
          page: pageNo,
          financialYear: financialYear,
          ...(userState?.usertype_keyname?.includes("zonalofficer") && {
            zonekey: userState?.zonekey,
          }),
          ...((userState?.usertype_keyname?.includes("mavim") ||
              userState?.usertype_keyname?.includes("sakshama")) &&
              userState?.organizationZone?.length > 0 && {
              zonekeyArray: userState.organizationZone.map(zone => String(zone.zonekey))
          })
        }),
      }
    )
      .then((res) => res.json())
      .then((response) => {
        if (response.status === 200) {
          setApiLoader(false);
          setContractor(response);
          setNoOfPages(response.noOfPages);
        } else {
          setApiLoader(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setApiLoader(false);
      });
  };

  return (
    <div className="visitReport">
      <ToastContainer />
      <Container>
        <Row className="visitors mt-2">
          <div className="container tbl-container p-0">
            <div className="row tbl-fixed p-0" style={{ maxHeight: "65vh" }}>
              <Table responsive="lg" hover>
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>Property Code</th>
                    <th>Property Owner Name</th>
                    <th>Property Owner Contact No</th>
                    <th>Property Address</th>
                    <th>Zone Name</th>
                    <th>Gat Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {apiLoader ? (
                    <tr>
                      <td colSpan={8} className="text-center">
                        <Spinner />
                      </td>
                    </tr>
                  ) : contractor?.data?.length > 0 ? (
                    contractor?.data?.map((row, index) => (
                      <tr key={index}>
                        <td>
                          {pageNo !== 1
                            ? index + 1 + docPerPage * (pageNo - 1)
                            : index + 1}
                        </td>
                        <td>{row?.propertyCode || "-"}</td>
                        <td>{row?.propertyName || "-"}</td>
                        <td>{row?.propertyContactNo || "-"}</td>
                        <td>{row?.propertyAddress || "-"}</td>
                        <td>{row?.zonename || "-"}</td>
                        <td>{row?.gatname || "-"}</td>
                        <td className="text-center">
                          <Icon.Eye
                            className="me-2"
                            style={{ cursor: "pointer" }}
                            size={25}
                            onClick={() => {
                              localStorage.setItem("report", JSON.stringify(row));
                              navigate("/dashboard/view-delete-report");
                            }}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={8} className="text-center">
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            {/* Pagination - always visible below table */}
            <Row className="mr-20">
              <Col md={4} className="d-flex align-items-center mt-3 mt-md-0">
                <h6 className="text-start mb-0">
                  <Icon.People className="me-2" />
                  Total - <strong>{contractor?.count || 0}</strong>
                </h6>
              </Col>
              <Col md={8} className="d-flex justify-content-end">
                <Pagination
                  currentPage={pageNo}
                  totalPages={noOfPages}
                  onPageChange={handlePageChange}
                  onDocsPerPage={handleDocsPerPage}
                  docsPerPage={docPerPage}
                />
              </Col>
            </Row>

          </div>
        </Row>
      </Container>
    </div>
  );
};

export default DeleteBillHistory;